import React from 'react'
import PropTypes from 'prop-types'
import { Radio } from './dashboard-form/radio.controlled'

const VisibilityRadios = ({name, value, onChange, ...props}) => {
  return (
    <div>
      <div className="flex flex-wrap -mx-2 lg:mx-0">
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Radio
            className="mb-4 lg:mb-2"
            label="Public"
            id={`${name}_radio1`}
            value={1}
            checked={value === 1 || value === '1'}
            onChange={onChange}
            name={name}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Radio
            className="mb-4 lg:mb-2"
            label="User"
            id={`${name}_radio2`}
            value={2}
            checked={value === 2 || value === '2'}
            onChange={onChange}
            name={name}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Radio
            className="mb-4 lg:mb-2"
            label="Verified User"
            id={`${name}_radio3`}
            value={3}
            checked={value === 3 || value === '3'}
            onChange={onChange}
            name={name}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Radio
            className="mb-4 lg:mb-2"
            label="Organization"
            id={`${name}_radio4`}
            value={4}
            checked={value === 4 || value === '4'}
            onChange={onChange}
            name={name}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Radio
            className="mb-4 lg:mb-2"
            label="My Organization"
            id={`${name}_radio5`}
            value={5}
            checked={value === 5 || value === '5'}
            onChange={onChange}
            name={name}
          />
        </div>
      </div>
    </div>
  )
}

VisibilityRadios.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func
}

VisibilityRadios.defaultProps = {
  name: '',
  value: 1,
  onChange: () => {}
}

export { VisibilityRadios }
